import { CATEGORIES, ZVANJA } from "../data/pravilnik";

const ITEM_MAP = {};
CATEGORIES.forEach((cat) =>
  cat.items.forEach((item) => {
    ITEM_MAP[item.id] = { ...item, catId: cat.id };
  })
);

export function calculatePoints(counts) {
  const byCategory = {};
  CATEGORIES.forEach((c) => (byCategory[c.id] = 0));
  let total = 0;
  Object.entries(counts).forEach(([id, count]) => {
    const item = ITEM_MAP[id];
    const n = Number(count) || 0;
    if (!item || n <= 0) return;
    const pts = n * item.points;
    byCategory[item.catId] += pts;
    total += pts;
  });
  const activeCategories = Object.values(byCategory).filter((p) => p > 0).length;
  return { byCategory, total, activeCategories };
}

export function evaluate(targetId, basic, calc) {
  const req = ZVANJA[targetId];
  const staz = Number(basic.staz) || 0;
  const kpr = Number(basic.kpr) || 0;
  const prevYears = Number(basic.prevYears) || 0;

  const useAlt = targetId === "mentor" && staz >= req.alt.staz && staz < req.staz;
  const neededPoints = useAlt ? req.alt.points : req.points;
  const neededCats = useAlt ? req.alt.minCat : req.minCat;
  const neededStaz = useAlt ? req.alt.staz : req.staz;

  const checks = [
    {
      id: "staz",
      label: `Godine staža u školskoj ustanovi (najmanje ${neededStaz})`,
      ok: staz >= neededStaz,
      value: `${staz} / ${neededStaz} god.`,
      missing: staz < neededStaz ? `Nedostaje još ${neededStaz - staz} god. staža` : null,
    },
    {
      id: "kpr",
      label: `Sati stručnog usavršavanja u posljednjih 5 godina (najmanje ${req.kpr})`,
      ok: kpr >= req.kpr,
      value: `${kpr} / ${req.kpr} sati`,
      missing: kpr < req.kpr ? `Nedostaje još ${req.kpr - kpr} sati usavršavanja` : null,
    },
  ];

  if (req.prev) {
    checks.push({
      id: "prev",
      label: `Godine provedene u zvanju ${req.prev.zvanje} (najmanje ${req.prev.years})`,
      ok: prevYears >= req.prev.years,
      value: `${prevYears} / ${req.prev.years} god.`,
      missing:
        prevYears < req.prev.years
          ? `Nedostaje još ${req.prev.years - prevYears} god. u zvanju ${req.prev.zvanje}`
          : null,
    });
  }

  checks.push({
    id: "points",
    label: `Ukupan broj bodova (najmanje ${neededPoints})`,
    ok: calc.total >= neededPoints,
    value: `${calc.total} / ${neededPoints} bodova`,
    missing: calc.total < neededPoints ? `Nedostaje još ${neededPoints - calc.total} bodova` : null,
  });

  checks.push({
    id: "cats",
    label: `Bodovi ostvareni u najmanje ${neededCats} kategorije/a`,
    ok: calc.activeCategories >= neededCats,
    value: `${calc.activeCategories} / ${neededCats} kategorija`,
    missing:
      calc.activeCategories < neededCats
        ? `Potrebni su bodovi iz još ${neededCats - calc.activeCategories} kategorije/a`
        : null,
  });

  const mandatoryOk = req.mandatory.every((catId) => calc.byCategory[catId] > 0);
  checks.push({
    id: "mandatory",
    label: "Bodovi u obveznoj kategoriji »Unaprjeđivanje rada škole«",
    ok: mandatoryOk,
    value: `${calc.byCategory["F"]} bodova`,
    missing: !mandatoryOk ? "Potreban je barem 1 bod u kategoriji Unaprjeđivanje rada škole" : null,
  });

  return {
    checks,
    eligible: checks.every((c) => c.ok),
    useAlt,
    neededPoints,
    neededCats,
  };
}
